// 2026-10-05 · Admin › Versiones. Identidad del build que está corriendo:
// «1.9.0+abc1234.202610051430» = REACT_APP_VERSION (número humano) + commit
// corto + fecha UTC del build. La estampa scripts/with-build-info.js en
// `npm run build|dev|prod`; en `npm start` y en jest no hay estampa → «+dev».
//
// Viaja en la cabecera X-Client-Version de cada petición (el API la guarda
// en Devices.ClientVersion) y se compara con public/version.json para avisar
// de que hay una versión nueva.
const VERSION = process.env.REACT_APP_VERSION || "0.0.0";
const COMMIT = process.env.REACT_APP_BUILD_COMMIT || null;
const TIME = process.env.REACT_APP_BUILD_TIME || null;

export const IS_STAMPED_BUILD = !!(COMMIT && TIME);
export const BUILD_ID = IS_STAMPED_BUILD ? `${VERSION}+${COMMIT}.${TIME}` : `${VERSION}+dev`;

/**
 * «1.9.0 · abc1234 · 05/10 14:30» para mostrar una versión (la propia o la
 * de otro dispositivo). Lo que no tenga el formato se devuelve tal cual.
 */
export function formatBuildId(id) {
  if (!id) return "desconocida";
  const m = /^([^+]+)\+([^.]+)\.(\d{12})$/.exec(String(id));
  if (!m) return String(id);
  const [, version, commit, t] = m;
  const date = new Date(Date.UTC(+t.slice(0, 4), +t.slice(4, 6) - 1, +t.slice(6, 8), +t.slice(8, 10), +t.slice(10, 12)));
  const pad = (n) => String(n).padStart(2, "0");
  const local = `${pad(date.getDate())}/${pad(date.getMonth() + 1)} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
  return `${version} · ${commit} · ${local}`;
}
